import { render, staticRenderFns } from "./FormHideSalary.vue?vue&type=template&id=2be4c0a9"
import script from "./FormHideSalary.vue?vue&type=script&lang=js"
export * from "./FormHideSalary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports